import { render, staticRenderFns } from "./AffiliateSaleItem.vue?vue&type=template&id=f038f6b8&scoped=true&"
import script from "./AffiliateSaleItem.vue?vue&type=script&lang=js&"
export * from "./AffiliateSaleItem.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateSaleItem.vue?vue&type=style&index=0&id=f038f6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f038f6b8",
  null
  
)

component.options.__file = "AffiliateSaleItem.vue"
export default component.exports